import Button from "./Button";
import IconGenerator from "./IconGenerator";
import Tooltip from "./Tooltip";
import * as allMui from "@mui/material";

// TODO: find solution here to find how to export module directly
let data = { allMui, IconGenerator };

export { Button, Tooltip, IconGenerator };
